import axios from 'axios';
import { user } from '../store';
import apiClientConfig from './config';

const API = apiClientConfig[process.env.NODE_ENV || 'development'];
const PLATFORM = {
  plat: '',
  plat_name: ''
};


export type Method = 'GET' | 'POST' | 'PUT' | 'DELETE';

export interface APIConfig {
  defaultToken?: string;
}

async function apiRequest(
  method: Method,
  url: string,
  data: any,
  config: APIConfig
) {
  let requestData = data;
  let params = data;

  if (method === 'GET') {
    requestData = null;
  } else {
    params = null;
  }

  const token = user.token;

  const response = await axios(url, {
    data: requestData,
    headers: {
      token
    },
    method,
    params
  });

  if (response.data.status === 80003) {
    user.logout();
    user.login();
  }

  return response.data;
}

function createClient(
  method: Method,
  url: string,
  defaultData: any = {},
  defaultConfig: APIConfig = {}
) {
  return (data?: any, apiConfig: APIConfig = {}) => {
    const config = {
      ...defaultConfig,
      ...apiConfig
    };

    const requestData = {
      ...defaultData,
      ...data
    };

    return apiRequest(method, url, requestData, config);
  };
}

function createBaseClient(
  method: Method,
  url: string,
  defaultData: any = {},
  defaultConfig: APIConfig = {}
) {
  return createClient(method, API.BASE_HOST + url, defaultData, defaultConfig);
}

const apiClient = {
  base: {
    /**
     *0011-账号登录 
     *0012-创建账号 
     *type-1管理员、2销售、3分拣员
    **/
    userApi: createBaseClient('POST', '/v1/user'),
    /**
     *0013-用户列表
     *0014-用户详情
    **/
    userListInfo: createBaseClient('GET', '/v1/user'),
    /**
     *0015-更改用户信息
     *0016-更改用户密码
    **/
    userEdit: createBaseClient('PUT', '/v1/user'),
    /**
     *0017-删除用户
    **/
    userDelete: createBaseClient('DELETE', '/v1/user'),
    /**
     *0021-创建订单
    **/
    orderAdd: createBaseClient('POST', '/v1/order'),
    /**
     *0022-订单列表
     *0023-订单详情
     *0026-订单统计
     *status-0待确认，1待审核，2待发货，3已发货
    **/
    orderListInfo: createBaseClient('GET', '/v1/order'),
    /**
     *0024-更改订单
    **/
    orderEdit: createBaseClient('PUT', '/v1/order'),
    /**
     *0025-删除订单
    **/
    orderDelete: createBaseClient('DELETE', '/v1/order')
  }
};

export default apiClient;
